import * as React from "react";
import { forwardRef, memo } from "react";
const SvgExpandMore = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M480-362q-8 0-15-2.5t-13-8.5L267-558q-11-11-10.5-27.5T268-613t28-11 28 11l156 156 157-157q11-11 27.5-10.5T692-613t11 28-11 28L508-373q-6 6-13 8.5t-15 2.5" })));
const ForwardRef = forwardRef(SvgExpandMore);
const Memo = memo(ForwardRef);
export default Memo;
